export const STAGES = [
  { key: "new_enquiry", label: "New Enquiry", dot: "bg-sky-500", badge: "bg-sky-100 text-sky-800", col: "bg-sky-50/60 border-sky-200" },
  { key: "intro_call", label: "Intro Call", dot: "bg-violet-500", badge: "bg-violet-100 text-violet-800", col: "bg-violet-50/60 border-violet-200" },
  { key: "proposal_sent", label: "Proposal Sent", dot: "bg-amber-500", badge: "bg-amber-100 text-amber-800", col: "bg-amber-50/60 border-amber-200" },
  { key: "onboarding", label: "Onboarding", dot: "bg-emerald-500", badge: "bg-emerald-100 text-emerald-800", col: "bg-emerald-50/60 border-emerald-200" },
  { key: "active_client", label: "Active Client", dot: "bg-teal-600", badge: "bg-teal-100 text-teal-800", col: "bg-teal-50/60 border-teal-200" },
  { key: "lost", label: "Lost", dot: "bg-rose-500", badge: "bg-rose-100 text-rose-800", col: "bg-rose-50/60 border-rose-200" },
];

export const stageMeta = (key) => STAGES.find((s) => s.key === key) || STAGES[0];

export const SERVICES = [
  "Annual Accounts",
  "VAT Returns",
  "Payroll",
  "Bookkeeping",
  "Self Assessment",
  "Corporation Tax",
  "Advisory",
  "R&D Tax Credits",
];

export const COMPANY_TYPES = ["LTD", "LLP", "Sole Trader", "Partnership", "Startup", "Charity"];

export const REVENUE_BRACKETS = [
  "Under £50k",
  "£50k–£100k",
  "£100k–£250k",
  "£250k–£500k",
  "£500k–£1m",
  "£1m+",
];

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n || 0);
